import { render, staticRenderFns } from "./BreadcrumbArea.vue?vue&type=template&id=12b4fd8d&scoped=true&"
import script from "./BreadcrumbArea.vue?vue&type=script&lang=ts&"
export * from "./BreadcrumbArea.vue?vue&type=script&lang=ts&"
import style0 from "./BreadcrumbArea.vue?vue&type=style&index=0&id=12b4fd8d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b4fd8d",
  null
  
)

export default component.exports